import React from 'react'
import { useParams } from 'react-router-dom'
import Colors from 'colors.json'

import { faCircle, faSearch, faRemoveFormat } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import Button from 'components/Button'
import Dropdown from 'components/Dropdown'
import { Form, Formik, FormikHelpers } from 'formik'

import { ProfileUpdateStatusSchemas } from 'schemas/profileUpdateStatusSchemas'
import { useProfileUpdate } from './useUpdateStatus'
import { MEMBER_GENDER } from 'constants/filters'
import { DropDownItem } from 'types/components'

const Index: React.FC<{ onCloseModal: () => void }> = ({
  onCloseModal,
}): React.ReactElement => {
  // STATES
  const { traderId } = useParams()
  const {
    member,
    memberStatuses,
    isLoading,
    initialValues,
    handleSubmitStatusUpdate,
    handleClearProfileUpdate,
  } = useProfileUpdate(Number(traderId), onCloseModal)

  if (isLoading) return <></>

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={ProfileUpdateStatusSchemas}
      onSubmit={handleSubmitStatusUpdate}
    >
      {({ values, isSubmitting, setFieldValue, errors, touched }) => {
        return (
          <Form>
            <div className="mb-4" style={{ height: '250px' }}>
              <p className="mb-4 flex items-center gap-2 font-light tracking-wider">
                <span>Current Status:</span>
                <Icon
                  icon={faCircle}
                  color={
                    member?.memberThorStatusId === 1 ||
                      member?.memberThorStatusId === 4 ||
                      member?.memberThorStatusId === 15
                      ? 'green'
                      : 'red'
                  }
                />
                <span className="font-normal">{member?.memberThorStatus}</span>
              </p>
              <Dropdown
                title="Change Status to"
                placeholder="Select a new status"
                options={memberStatuses.map((status) => ({
                  label: status.statusName,
                  value: String(status.statusId),
                }))}
                borderColor="#C4C4C4"
                onSelect={(item) => {
                  setFieldValue('newStatusId', item.value)
                }}
              />
              {errors.newStatusId && (
                <p className="mt-1 text-sm text-red-600">
                  {errors.newStatusId}
                </p>
              )}
            </div>

            <footer className="flex justify-end pb-4 pl-4 pr-4">
              <Button
                type="submit"
                className="mr-2 rounded bg-primary"
                disabled={isSubmitting}
              >
                <span className="tracking-wider font-bold">Confirm</span>
              </Button>
              <Button
                className="bg-white border rounded border-primary"
                onClick={onCloseModal}
                style={{ color: Colors.primary }}
              >
                <span className="tracking-wider font-bold">Cancel</span>
              </Button>
            </footer>
          </Form>
        )
      }}
    </Formik>
  )
}

export default Index
